import React from 'react';
import appConfig from '../../app-config';
import './footer.scss';

export default class Header extends React.Component {
  render() {
    return (
      <footer className={'footer fixed-bottom ' + (window.location.pathname === '/' ? 'fp-footer-left-offset' : '')}>
        <div className='footer-copyright'>
          <a className='footer-copyright-link' href='/' target='_blank' rel="noreferrer">{appConfig.app.title}</a>
          <span className='footer-copyright-divider'> | </span>
          <span className='footer-copyright-year'>Copyright © {appConfig.app.year}</span>
          <span className='footer-copyright-divider'> | </span>
          <a className='footer-social-media' title='Flickr' href='https://www.flickr.com/fpdigitalphoto/' target='_blank' rel="noreferrer"><i className='fa fa-brands fa-flickr' /></a>
          {/* <a className='footer-social-media' title='Facebook' href='https://www.facebook.com/fpdigitalphoto' target='_blank' rel="noreferrer"><i className='fa fa-brands fa-facebook-official' /></a> */}
          <a className='footer-social-media' title='Instagram' href='https://www.instagram.com/fpdigitalphoto/' target='_blank' rel="noreferrer"><i className='fa fa-brands fa-instagram' /></a>
        </div>
      </footer>
    );
  }
}